export const getDefaultLanguage = (): string | undefined => {
  const lang = new URLSearchParams(window.location.search).get('lang');
  if (lang === null) {
    return undefined;
  }
  return lang;
};
